import { BuildClass, getFileTypeInfoFromMIME, tw } from '../../../../universal';
import { React } from '../../../lib';
import { CustomPDFContainer } from '../../component-pdf-viewer';
import { LoadingSpinnerLarge } from '../loading';
export const NoteAttachment = (props) => {
    const attachment = props.attachment;
    if (!attachment || !attachment.Checksum) {
        return React.createElement(React.Fragment, null);
    }
    const url = `https://storage.trionline.com.au/get/${attachment.Checksum}`;
    const [fileTypeInfo, setFileTypeInfo] = React.useState(getFileTypeInfoFromMIME(attachment.MimeType));
    const [hasCheckedFileInfo, setHasCheckedFileInfo] = React.useState(false);
    React.useEffect(() => {
        console.log({
            attachment,
            fileTypeInfo,
            hasCheckedFileInfo,
        });
        if (!attachment.MimeType && !hasCheckedFileInfo) {
            fetch(`https://storage.trionline.com.au/get/${attachment.Checksum}/`)
                .then(async (res) => res.blob())
                .then(blob => {
                console.log({ type: blob.type });
                setFileTypeInfo(getFileTypeInfoFromMIME(blob.type));
                setHasCheckedFileInfo(true);
            })
                .catch(console.error);
        }
    }, [attachment.MimeType, attachment.Checksum]);
    if (!attachment.MimeType && !hasCheckedFileInfo) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const wrappingClassName = tw `w-full h-full text-center overflow-y-auto`;
    if (fileTypeInfo.type == 'image') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("img", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'video') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("video", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'audio') {
        return (React.createElement("div", { className: wrappingClassName },
            React.createElement("audio", { className: "mx-auto", src: url })));
    }
    if (fileTypeInfo.type == 'pdf') {
        return React.createElement(CustomPDFContainer, { url: url });
    }
    return (React.createElement("div", { className: wrappingClassName },
        React.createElement("a", { href: url, className: BuildClass([
                'w-full p-2',
                'text-blue-600 text-lg',
                'hover:text-red-600 cursor-pointer',
            ]), target: "_blank" }, getAttachmentGeneratedFilename(attachment))));
};
export const getAttachmentGeneratedFilename = (attachment) => {
    const fileTypeInfo = getFileTypeInfoFromMIME(attachment.MimeType);
    return fileTypeInfo.extension ? `attachment.${fileTypeInfo.extension}` : 'attachment';
};
//# sourceMappingURL=attachments.js.map